import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Notification as NotificationBase } from '@alfalab/core-components-notification';
import { Stack } from '@alfa-bank/site-stack';

import { Notification as Component } from '../notification';
import type { TNotificationDesktop, IDeps } from '../models';

import { config } from './config';
import styles from './styles.css';

export const NotificationDesktop = createWidget<IDeps, TNotificationDesktop>(
    {
        NotificationBase,
        Stack,
        config,
        styles,
    },
    { priorityStyler: true }
)(Component);
